import _ from 'underscore';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Grid, Col, Row, Label } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SearchBox } from '@bingads-webui-react/search-box-control';
import SourceCategory from './source-category';
import SourceListBox from './source-list-box';
import SelectedListBox from './selected-list-box';
import ButtonBack from './button-back';
import Item from './item';
import { doubleListBoxStyles } from './get-styles';

export class DoubleListBoxView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCategory: null,
      query: '',
      searchValue: null,
    };
  }

  onSearch = (query) => {
    this.setState({
      searchValue: query,
    });
  };

  onQueryChange = (query) => {
    this.setState({
      searchValue: null,
      query,
    });
  };

  selectCategory = (selectedCategory) => {
    this.setState({
      currentCategory: selectedCategory,
    });
  }

  renderSourceCategoriesContent = data => (
    <ButtonGroup vertical>
      {data.map((categoryObject, index) => (
        <SourceCategory
          className={this.props.classes.sourceCategory}
          key={categoryObject.name}
          title={categoryObject.name}
          body={categoryObject.description}
          disabled={categoryObject.disabled || false}
          category={index}
          onChange={this.selectCategory}
          i18n={this.props.i18n}
          isShow={!categoryObject.notShowInSource}
        />))}
    </ButtonGroup>
  )

  renderSourceCategoriesSearchResults = (data) => {
    const categoriesResult = _.map(data, (categoryObject, index) => {
      const list = _.difference(categoryObject.data.items, categoryObject.data.selected);
      const categoryResult = (this.state.searchValue ? list.filter(item =>
        item.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) > -1) : list);

      return {
        name: categoryObject.name,
        result: categoryResult,
        key: index,
        disabled: categoryObject.disabled || false,
      };
    }).filter(categoryResult => categoryResult.result.length > 0);

    return (
      <Grid fluid className={this.props.classes.sourceCategoriesSearchResults}>
        {categoriesResult.map(categoryResult =>
          (
            <Row key={categoryResult.key}>
              <Col sm={12}>
                <Row>
                  <Col sm={12}>
                    <span className="category-name">{categoryResult.name}</span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    {
                      categoryResult.result.map(item =>
                        (<Item
                          key={item}
                          value={item}
                          selected={false}
                          disabled={categoryResult.disabled}
                          onChange={() => this.props.onChange(true, categoryResult.key, [item])}
                          i18n={this.props.i18n}
                        />))
                    }
                  </Col>
                </Row>
              </Col>
            </Row>))
        }
      </Grid>
    );
  }

  renderSourceCategories = (data, onChange) => (
    <Grid fluid className={`source-categories ${this.props.classes.sourceCategories}`}>
      <Row>
        <Col sm={12}>
          <Row>
            <Col sm={12}>
              <SearchBox
                onQueryChange={this.onQueryChange}
                onSearch={this.onSearch}
                value={this.state.query}
                classes={{ input: 'input', icon: 'icon', inputGroup: 'inputGroup' }}
                placeholder={this.props.i18n.getString('DoubleListBox_SearchBoxPlaceholder')}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {
                this.state.searchValue ?
                  this.renderSourceCategoriesSearchResults(data, onChange) :
                  this.renderSourceCategoriesContent(data)
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
  )

  renderSourceListBox = (data, currentCategory, onChange) => (
    <SourceListBox
      className={`source-list-box ${this.props.classes.sourceListBox}`}
      searchBoxClasses={{ input: 'input', icon: 'icon', inputGroup: 'inputGroup' }}
      data={data[currentCategory]}
      onChange={onChange}
      category={currentCategory}
      goBack={this.selectCategory}
      i18n={this.props.i18n}
    />
  )

  renderSelectedListBox = (data, onChange) => (
    <Grid fluid className={`selected-list-box-group ${this.props.classes.selectedListBoxGroup}`}>
      <Row>
        <Col sm={12}>
          <Row>
            <Col sm={12}>
              {data.map((categoryObject, index) => (
                <SelectedListBox
                  className={this.props.classes.selectedListBox}
                  key={categoryObject.name}
                  categoryObject={categoryObject}
                  onChange={onChange}
                  category={index}
                  selected
                  i18n={this.props.i18n}
                />
              ))}
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
  )

  render() {
    const { data, onChange } = this.props;
    const isCategorySelected = this.state.currentCategory !== null;

    return (
      <Grid className={`double-list-box ${this.props.classes.doubleListBox}`}>
        <Row>
          <Col
            sm={5}
            className={`source ${this.props.classes.listBoxContainer}`}
          >
            <Row className={this.props.classes.listBoxHeader}>
              {
                isCategorySelected ?
                  (
                    <Label>
                      <ButtonBack
                        className={this.props.classes.buttonBack}
                        i18n={this.props.i18n}
                        onClick={this.selectCategory}
                      />
                      {`${data[this.state.currentCategory].name}: ${data[this.state.currentCategory].data.items.length}`}
                    </Label>
                  ) :
                  (<Label>{this.props.i18n.getString('DoubleListBox_HeaderSource')}</Label>)
              }
            </Row>
            <Row className={this.props.classes.listBoxContent}>
              {
                isCategorySelected ?
                  this.renderSourceListBox(data, this.state.currentCategory, onChange) :
                  this.renderSourceCategories(data)
              }
            </Row>
          </Col>
          <Col
            sm={5}
            className={`selected ${this.props.classes.listBoxContainer}`}
          >
            <Row className={this.props.classes.listBoxHeader}>
              <Label>{this.props.i18n.getString('DoubleListBox_HeaderSelected')}</Label>
            </Row>
            <Row className={this.props.classes.listBoxContent}>
              {this.renderSelectedListBox(data, onChange)}
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

DoubleListBoxView.propTypes = {
  /**
   * Data passed down (do not modify directly)
   * Holds an array of 'category objects,' described below
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    data: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
      selected: PropTypes.arrayOf(PropTypes.string),
      disabled: PropTypes.arrayOf(PropTypes.string),
      showUnavailableItem: PropTypes.bool,
    }).isRequired,
    notShowInSource: PropTypes.bool,
  })).isRequired,
  /**
   * Onchange function to handle select/deselect logic
   * Parameters:
   *    add, bool, if select or deselct
   *    category, string, current selected category or all if null
   *    name, string, item to be selected or deselected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * class names that come from jss theme or default style
   */
  classes: PropTypes.shape({
    doubleListBox: PropTypes.string,
    listBoxContainer: PropTypes.string,
    listBoxHeader: PropTypes.string,
    listBoxContent: PropTypes.string,
    sourceCategories: PropTypes.string,
    sourceCategoriesSearchResults: PropTypes.string,
    sourceCategory: PropTypes.string,
    sourceListBox: PropTypes.string,
    selectedListBoxGroup: PropTypes.string,
    selectedListBox: PropTypes.string,
    buttonAddRemove: PropTypes.string,
    buttonBack: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

export const DoubleListBoxViewThemed = withDefaultStyles(DoubleListBoxView, doubleListBoxStyles);
// TODO: export both hoc and non-hoc version
